/* eslint no-param-reassign: ["error", { "props": true, "ignorePropertyModificationsFor": ["draft"] }] */
import produce from 'immer';

import {
  FeatureFlagSharedDataAction,
  FeatureFlagSharedDataState,
} from '@/types/featureFlagSharedData';

export const initialState: FeatureFlagSharedDataState = {
  'growth-sc-move-caregiver-tasks-to-paj': '',
  'growth-seo-seeker-single-page-enrollment': '',
  'martech-482-a-b-test-single-page-enrollment-marketing-mfe': '',
  'growth-enrollment-cc-paywall-test': 0,
  'growth-enrollment-cc-condense-account-creation': 0,
  'growth-enrollment-seeker-overhaul-cc-m1': 0,
  'enrollment-seeker-overhaul-cc-m1-enabled': false,
};

export const FeatureFlagSharedDataReducer = produce(
  (draft: FeatureFlagSharedDataState, action: FeatureFlagSharedDataAction) => {
    switch (action.type) {
      case 'updateFeatureFlagSharedData': {
        draft[action.flagName] = action.flagValue;
        return draft;
      }
      default:
        return draft;
    }
  }
);

export const reducer = (state: FeatureFlagSharedDataState, action: FeatureFlagSharedDataAction) => {
  return FeatureFlagSharedDataReducer(state, action as FeatureFlagSharedDataAction);
};
